export const MUSE_CONFIG_CONTENT_TYPE = 'muse-config'
export const MUSE_CONFIG_PAGE_ID = ''
export const MUSE_CONFIG_VERSION_ID = ''
export const MUSE_SEARCH_SECTION = '[Muse] Busca'
export const MUSE_PLP_SECTION = '[Muse] PLP'
export const MUSE_PDP_SECTION = '[Muse] PDP'

export type MuseSurfaceFlags = {
  enableSession: boolean
  showOnDesktop: boolean
  showOnMobile: boolean
}

export type MusePlpConfig = MuseSurfaceFlags & {
  title?: string
  subtitle?: string
  ctaLabel?: string
}

export type MuseEntryPointsConfig = {
  search: MuseSurfaceFlags
  plp: MusePlpConfig
  pdp: MuseSurfaceFlags
}

type CmsSection = {
  name?: string
  data?: Record<string, unknown>
}

type CmsPage = {
  sections?: CmsSection[]
}

function asBoolean(value: unknown) {
  return value === true
}

function asOptionalString(value: unknown) {
  return typeof value === 'string' ? value : undefined
}

function findSection(sections: CmsSection[] | undefined, name: string) {
  return sections?.find((item) => item.name === name)
}

function parseSurfaceFlags(raw: unknown): MuseSurfaceFlags {
  const data =
    raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {}

  return {
    enableSession: asBoolean(data.enableSession),
    showOnDesktop: data.showOnDesktop !== false,
    showOnMobile: data.showOnMobile !== false,
  }
}

export function parseMuseEntryPointsConfig(
  cmsData: CmsPage | null | undefined
): MuseEntryPointsConfig | null {
  const sections = cmsData?.sections
  const searchSection = findSection(sections, MUSE_SEARCH_SECTION)
  const plpSection = findSection(sections, MUSE_PLP_SECTION)
  const pdpSection = findSection(sections, MUSE_PDP_SECTION)

  if (!searchSection && !plpSection && !pdpSection) {
    return null
  }

  const plpData = plpSection?.data ?? {}

  return {
    search: parseSurfaceFlags(searchSection?.data),
    pdp: parseSurfaceFlags(pdpSection?.data),
    plp: {
      ...parseSurfaceFlags(plpData),
      title: asOptionalString(plpData.title),
      subtitle: asOptionalString(plpData.subtitle),
      ctaLabel: asOptionalString(plpData.ctaLabel),
    },
  }
}
